export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 50%, oklch(0.595 0.185 22) 0%, transparent 50%), radial-gradient(circle at 80% 50%, oklch(0.725 0.170 85) 0%, transparent 50%)',
        }}
      />

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-line"></i>
              </span>
              <span>今日更新 128 条</span>
              <span className="w-1 h-1 rounded-full bg-primary-400"></span>
              <span>在线吃瓜 36.8万人</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4">
              51吃瓜app
              <span className="block text-primary-500 mt-1">
                热门人物吃瓜第一站
              </span>
            </h1>

            <p className="text-lg text-foreground-500 font-heading font-medium mb-5">
              台北娜娜 · 莫里秀 · 玩偶姐姐 · 独家爆料一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              51吃瓜app专注热门人物专题，聚焦台北娜娜最新动态、莫里秀独家合集、玩偶姐姐深度追踪等一线吃瓜内容。
              每日更新热门人物最新爆料与视频合集，让你不错过任何一个瓜。平台覆盖全网热门人物话题，
              提供第一手资讯、深度分析和粉丝互动，是吃瓜群众获取娱乐八卦资讯的首选入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-900">
                  8,600+
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">独家爆料</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-900">
                  日均更新
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">120+ 条内容</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-900">
                  200万+
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">活跃吃瓜群众</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#index')}
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-compass-3-line"></i>
                </span>
                立即吃瓜
              </button>
              <button
                onClick={() => handleScroll('#app')}
                className="w-full sm:w-auto px-7 py-3 border border-background-300 hover:border-foreground-300 text-foreground-700 hover:text-foreground-900 font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-download-2-line"></i>
                </span>
                下载APP
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-primary-200/30 via-accent-100/20 to-secondary-100/20 blur-xl" />
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20entertainment%20news%20collage%20with%20warm%20golden%20and%20coral%20accents%2C%20abstract%20geometric%20shapes%20overlapping%20with%20soft%20gradients%2C%20digital%20media%20aesthetic%20with%20glowing%20highlights%2C%20sophisticated%20magazine%20style%20layout%20on%20clean%20light%20background%2C%20trending%20topics%20visualized%20as%20floating%20cards%20in%20warm%20amber%20and%20coral%20tones&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                alt="51吃瓜app热门人物吃瓜专题主视觉"
                className="relative w-full h-auto rounded-xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}